import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { Menu, MenuList } from '../../models/menu';

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  private _menu: ReplaySubject<Menu> = new ReplaySubject<Menu>(1);
  menu$ = this._menu.asObservable();

  menuOnChange(menu: Menu) {
    this._menu.next(menu);
  }

  getMenuItem(routeName: string): Menu | undefined {
    const segments = routeName.split('/');
    let currentList = MenuList;
    let hierarchicalMatch: Menu | undefined;

    for (let i = 0; i < segments.length; i++) {
      const match = currentList.find((m) => m.route === segments[i]);
      if (match) {
        if (i < segments.length - 1) {
          match.isExpanded = true;
          currentList = match.sub;
        } else {
          hierarchicalMatch = match;
        }
      } else {
        hierarchicalMatch = undefined;
        break;
      }
    }

    if (hierarchicalMatch) {
      return hierarchicalMatch;
    }

    // Fallback for legacy support or non-hierarchical calls
    const lastSegment = segments[segments.length - 1];
    for (const menu of MenuList) {
      if (menu.route === lastSegment) {
        return menu;
      }
      const subItem = menu.sub.find((sub) => sub.route === lastSegment);
      if (subItem) {
        menu.isExpanded = true;
        return subItem;
      }
    }
    return undefined;
  }
}
